import React from "react";

import { TRecommendation } from "../../types";
import { Link } from "react-router-dom";

import MoreInfo from "../../assets/Icons/MoreInfo";
import Button from "../Button";

const CardRecommendationInfo = ({
  name,
  subtype,
  potential_mangrove,
  project_type,
  mangrove_coverage,
  mangrove_degradation,
  name_one,
  country,
  id,
}: TRecommendation) => {
  return (
    <div className="w-full overflow-hidden rounded-xl bg-white p-4 shadow-lg">
      <div className="flex h-full flex-col justify-between">
        <div className="mb-10 flex-row items-start justify-between">
          <div className="flex">
            {/*<div className="mr-2 mt-2 flex h-8 w-full max-w-[2rem] grow items-center justify-center rounded-full bg-purple-700 text-white">*/}
            {/*  <div>A</div>*/}
            {/*</div>*/}
            <div className="grow-0">
              <div className="font-bold text-black">{name}</div>
            </div>
            <div className="mt-1 grow cursor-pointer text-gray-600">
              <MoreInfo />
            </div>
          </div>
        </div>
        <p className="mb-4 text-base text-gray-700">
          {subtype} in {name_one} of {country}. The potential mangrove ot {potential_mangrove} Ha
          highlights {project_type} with a conservation potential of {mangrove_coverage}, and
          {mangrove_degradation} with significant emission reduction.
        </p>
        <div className="flex justify-end gap-2">
          <Link to={`/project/${id}`}>
            <Button variant="outlined">More Details</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CardRecommendationInfo;
